/*
    Order of precendence for the .env files when running 'npm start'. 
    1.) .env
    2.) .env.local
    3.) .env.dev
    4.) .env.dev.local

    Order of precendence for the .env files when running 'npm run build'
    1.) .env
    2.) .env.local
    3.) .env.production
    4.) .env.production.local
*/

const config = {
  apimUrl: process.env.REACT_APP_APIM_URL,
  apimKeyAccountService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_KEY_ACCOUNT_SERVICE,
  apimKeyArtificialIntelligenceService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_AI_SERVICE,
  apimKeyAuthenticationService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_AUTHENTICATION_SERVICE,
  apimKeyEmailService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_EMAIL_SERVICE,
  apimKeyBusinessService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_BUSINESS_SERVICE,
  apimKeyServicesService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_SERVICES_SERVICE,
  apimKeyReviewService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_REVIEW_SERVICE,
  apimKeyAnalyticsService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_ANALYTICS_SERVICE,
  apimKeyWizardRequestService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_SERVICE_WIZARD_REQUEST,
  apimKeyBusinessLeadService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_BUSINESS_LEAD_SERVICE,
  apimKeyCrmService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_CRM_SERVICE,
  apimKeyStripeService:
    process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY_STRIPE_SERVICE,
  stripePublishableKey:
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  /** Public site origin for canonical / Open Graph URLs (no trailing slash). */
  siteUrl: process.env.REACT_APP_SITE_URL,
  /**
   * Deployment environment: `dev` | `uat` | `prd`.
   * Defaults to `dev` when unset (local). Used to gate production-only features (e.g. GA).
   */
  environment: process.env.REACT_APP_ENVIRONMENT,
};

export default config;
